import * as React from "react";

const PaperClipIosIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={23} height={23} fill="none" {...props}>
    <path
      fill="#858E99"
      d="m17.074 13.563-4.186 4.186a5.137 5.137 0 0 1-7.264-7.264l5.635-5.634a3.427 3.427 0 1 1 4.846 4.846l-5.812 5.812a1.61 1.61 0 1 1-2.277-2.277L12.38 8.87a.567.567 0 1 0-.802-.802L7.214 12.43a2.745 2.745 0 1 0 3.882 3.881l5.811-5.811a4.562 4.562 0 0 0-6.45-6.451L4.821 9.683a6.271 6.271 0 0 0 8.869 8.869l4.185-4.186a.567.567 0 1 0-.802-.803Z"
    />
  </svg>
);

export default PaperClipIosIcon;
